module.exports = __webpack_public_path__ + "img/empty_bg.2d7ae155.png";